exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pr[data-v-42736430] {\n  padding-right: 20px !important;\n}\n.pl[data-v-42736430] {\n  padding-left: 20px !important;\n}\np[data-v-42736430] {\n  color: #c5c5c5;\n}\n", ""]);

// exports
